import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";

import ResponseMessage from "./ResponseMessage";

export class ContactInfoConfirmSystemMessage extends Component {
    render() {
        const { message, scrollToBottom } = this.props;

        return (
            <Fragment>
                <ResponseMessage
                    author={message.author}
                    dateCreated={message.dateCreated}
                    id={message.id}
                    isFirstResponseMessage={message.isFirstResponseMessage}
                    isLoading={message.isLoading}
                    messageText={i18n.t("rtm.text.contact_info_confirmation_system_message")}
                    scrollToBottom={scrollToBottom}
                />
            </Fragment>
        );
    }
}

ContactInfoConfirmSystemMessage.propTypes = {
    message: PropTypes.shape({
        author: PropTypes.shape({}).isRequired,
        dateCreated: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        isFirstResponseMessage: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
    }).isRequired,
    scrollToBottom: PropTypes.func.isRequired,
};

export default ContactInfoConfirmSystemMessage;
